module.exports = __webpack_public_path__ + "static/icons/icon-snow-report--black-09eb94b1b0868c367794fd721249a23c.svg";